<template>
  <el-container class="survey-preview">
    <el-header class="px-0" v-if="!hiddenTopHeader">
      <ul class="h-full flex justify-center items-center text-theme-black-650 leading-22 bg-white">
        <router-link replace tag="li" :to="menu.path" v-for="menu in menus" :key="menu.meta.id" class="mr-8 last:mr-0">
          <span class="text-large-x">
            <i :class="menu.meta.icon"></i>
          </span>
          <span class="cursor-pointer">
            {{ menu.meta.label }}
          </span>
        </router-link>
      </ul>
    </el-header>
    <el-main class="p-0" :style="{ height: mainHeight }" v-loading="!surveyInit">
      <router-view class="h-full" v-if="surveyInit" />
    </el-main>
  </el-container>
</template>

<script>
import GlobalConfig from '@/global/config'
import { getSurveyById } from '@/api/survey'
import { mapGetters } from 'vuex'

export default {
  name: 'Preview',
  data() {
    return {
      menus: [],
      hiddenTopHeader: false
    }
  },
  computed: {
    mainHeight() {
      if (this.hiddenTopHeader) return '100vh'
      else return 'calc(100vh - 60px)'
    },
    ...mapGetters(['surveyInit'])
  },
  created() {
    GlobalConfig.setSurveyId(this.$route.params.id)
    this.hiddenTopHeader = GlobalConfig.getUrlParams().hiddenTopHeader
    this.menus = this.$dygcRouter.getChildrenByName('preview')
    this.versionId = this.$route.query.versionId // 版本记录用
    getSurveyById(GlobalConfig.getSurveyId(), this.versionId).then(res => {
      GlobalConfig.setSurveyVersionId(res.data.data.versionId)
      this.$store.dispatch('initSurvey', res.data.data)
    })
  },
  methods: {}
}
</script>

<style scoped lang="scss">
.router-link-active {
  @apply text-theme;
}
</style>
